import React from "react";
import { IColumn } from "../../../../yoello-lib/modules/components/PaginatedTable";
import { ProductListView } from "../productList/ProductListView";
import { ProductPageController } from "./ProductPageController";
import styles from "../../../../scss/productTableRows.module.scss";
import ProductListHeader from "../productList/ProductListHeader";
import "../../../../scss/itemsSearchBox.scss";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { useDialogRouteStages } from "../../../dialogRoutes/useDialogRouteStages";
import { MultiDialogRoute } from "../../../dialogRoutes/MultiDialogRoute";
import { CREATE_URL } from "../../../../const/URL.const";
import { useSideTabs } from "../../../../hooks/useSideTabs";
import { ISidebarItem } from "../../../Routes";

interface IProductPageProps<T> {
    productList: T[];
    isLoading: boolean;
    createButtonLabel: string;
    getSearchLabelFunction: (product: T) => string;
    columns: IColumn[];
    emptyListText: string;
    emptyListTextInfo: string;
    venueId: string;
    renderOptionFunction?: (product: T) => JSX.Element;
    fieldList: any[];
    buttonKey?: string;
    dialogRouteRows: IRouteSteps[];
    itemDialogKey: string;
    tab: ISidebarItem;
}

export function ProductPage<T>({
    productList,
    isLoading,
    createButtonLabel,
    getSearchLabelFunction,
    columns,
    emptyListText,
    emptyListTextInfo,
    renderOptionFunction,
    fieldList,
    buttonKey,
    dialogRouteRows,
    itemDialogKey,
    tab
}: IProductPageProps<T>) {
    let { path } = useRouteMatch();
    const history = useHistory();
    const { goToNextStep } = useDialogRouteStages(history);
    useSideTabs(tab);
    function selectItem(entry: T | null) {
        goToNextStep(itemDialogKey, {
            ComponentProps: {
                formData: entry ? entry : {},
            },
            isFormDialog: true,
            //@ts-ignore
        }, `${path}/${!entry ? CREATE_URL : entry?.id!}`)
    }

    return <Switch>
        <Route path={path}>
            <ProductPageController buttonKey={buttonKey} productList={productList} onItemSelect={selectItem}
                isLoading={isLoading} buttonLabel={createButtonLabel}
                getLabelFunction={getSearchLabelFunction} renderOptionFunction={renderOptionFunction} />
            {
                productList.length > 0
                    ?
                    <ProductListHeader columns={columns} />
                    :
                    <div />
            }

            <ProductListView
                listClassName={styles.productListViewContainer}
                isLoading={isLoading}
                productList={productList}
                onItemSelection={selectItem}
                sortAPICall={undefined}
                parentEntry={[]}
                emptyEntryText={emptyListText}
                emptyEntryTextInfo={emptyListTextInfo}
                emptyListText={emptyListText}
                emptyListTextInfo={emptyListTextInfo}
                fieldList={fieldList}
            />
            <MultiDialogRoute RouteSteps={dialogRouteRows} navigateBackRotue={path} />

        </Route>
    </Switch>;
}